import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

function StockDate({ companyName }) {
    const [latestData, setLatestData] = useState(null);
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [newsData, setNewsData] = useState(null);
    const url = location.state?.url;
    let id = location.state?.id;

    useEffect(() => {
        if (!url) return;
        setLoading(true);

        axios
            .post(`${process.env.REACT_APP_SPRING_API_URL}/api/parse-news`, {
                url,
                id: id || "",
            })
            .then((res) => {
                setNewsData(res.data);
            })
            .catch((err) => {
                console.error("뉴스 파싱 실패:", err);
                setNewsData(null);
            })
            .finally(() => setLoading(false));
    }, [location]);

    useEffect(() => {
        fetch(
            `${process.env.REACT_APP_SPRING_API_URL}/api/stock-data?company=${encodeURIComponent(
                companyName
            )}`
        )
            .then((res) => res.json())
            .then((data) => {
                let rows = [];
                if (Array.isArray(data)) rows = data;
                else if (data.data && Array.isArray(data.data)) rows = data.data;

                if (rows.length > 0) {
                    const lastRow = rows[rows.length - 1];
                    setLatestData({
                        date: lastRow.Date,
                        close: lastRow.Close,
                    });
                }
            })
            .catch((err) => console.error("데이터 로딩 실패:", err));
    }, [companyName]);

    if (!latestData) return <div>데이터 로딩 중...</div>;

    return (
        (latestData.date == formattedDate) ?
            (<p style={{ textAlign: "center" }}>날짜: {latestData.date}, 종가: {latestData.close}</p>)
            :
            (<p style={{ textAlign: "center" }}>날짜: {latestData.date}, 종가: {latestData.close} <br/>(장 미개장·미마감 또는 휴장일로 인해 가장 최근 확정된 종가 기준)</p>)
    )
}

export default StockDate;
